import {Utils} from '../../Utils';

declare var Highcharts: any;
declare var $: any;
import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {DashboardService} from '../../../dashboard/services/dashboard.service';
import {merge} from 'lodash';
import {utils} from "protractor";

@Component({
  selector: 'app-display-gas-trade-disposition',
  templateUrl: './display-gas-trade-disposition.component.html'
})
export class DisplayGasTradeDispositionComponent implements OnInit, OnDestroy {

  data: any;
  _chartOptions: any;
  _seriesOptions: any;
  displayChart: boolean = false;
  subscription: any;
  firstPointYear: any;
  lastPointYear: any;
  xLabels = [];
  @Input() title;

  constructor(public dashboardService: DashboardService) {
  }

  ngOnInit() {
    let controller = this;
    this.subscription = this.dashboardService.getGasTradeDisposition().subscribe(
      json => {
        this.data = json;
      },
      null, // error function
      () => {
        let exportMenuItems = merge([], (Highcharts.getOptions()).exporting.buttons.contextButton.menuItems);
        let component = this;

        exportMenuItems[0] = null;
        exportMenuItems[1] = null;
        exportMenuItems[4] = null;
        exportMenuItems[5] = null;

        this._chartOptions = {
          chart: {
            logo: Highcharts.logos.none,
            height: 300
          },
          title: {
            text: this.title
          },
          xAxis: {
              plotLines: [{
                  color: Highcharts.eia_grey,
                  width: 2,
                  value: 6.5,
                  dashStyle: 'Dash',
                  label: {
                      text: 'report week',
                      align: 'right',
                      rotation: 0,
                      y: -5,
                      x: -10
                  }
              },
                  {
                      color: 'rgba(0,0,0,0)',
                      width: 2,
                      value: 6.5,
                      dashStyle: 'Dash',
                      label: {
                          text: 'current week',
                          align: 'left',
                          rotation: 0,
                          y: -5,
                          x: 10
                      }
                  }],
            showFirstLabel: true,
            startOnTick: true,
            categories: controller.xLabels
          },
          yAxis: {
            title: {
              text: 'billion cubic feet per day'
            },
              plotLines: [{
                  value: 0,
                  color: 'black',
                  dashStyle: 'solid',
                  width: 2
              }],
            tickInterval: 2
          },
          legend: {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'bottom'
          },
          tooltip: {
            shared: true,
            formatter: function () {
              let formatter = this;

              function checkForData() {
                  let splitDate = formatter.x.split(' ');

                  let toolTipString = '';
                  toolTipString += '<div>' + Utils.monthsInYear[splitDate[0]] + ' ' + splitDate[1] + '</div><br>';
                formatter.points.forEach(function (element) {
                  const year = parseInt(element.series.name.substring(0, 4), 10);

                  if (element.series.options.id === 'previous_range') {
                    const yearString = component.getSeriesYearText(element.series.options.id);
                    toolTipString += '<div><b>' + yearString + ': </b>' + element.point.low + ' to ' + element.point.high + '</div>';
                  } else {
                    const yearString = component.getSeriesYearText(element.series.options.id);
                    toolTipString += '<div><b>' + yearString + ': </b>' + element.point.y + '</div><br>';
                  }
                });
                return toolTipString;
              }

              return checkForData();
            }
          },
          series: [],
          exporting: {
            buttons: {
              contextButton: {
                menuItems: exportMenuItems
              }
            }
          },
          credits : {
            enabled : false
          }
        };

        this._seriesOptions = {

          'current': {
            id : 'current',
            type: 'line',
            name: null,
            zIndex: 3,
              color: Utils.areaPlotColors.current
          },

          'previous_range': {
            id : 'previous_range',
            type: 'arearange',
            lineWidth: 0,
            name: null,
            zIndex: 0,
            color: Utils.areaPlotColors.range
          },
          'previous': {
            id : 'previous',
            type: 'line',
            name: null,
            zIndex: 1,
            color: Utils.areaPlotColors.previous
          },
        }


        this._chartOptions.series = [];

        this.firstPointYear = new Date(this.data[0].data[0][0]).getUTCFullYear();
        this.lastPointYear = new Date(this.data[0].data[this.data[0].data.length - 1][0]).getUTCFullYear();

        for (let j = 0; j < this.data.length; j++) {

          if (this._seriesOptions[this.data[j].id]) {
            let seriesOptions = merge({}, this._seriesOptions[this.data[j].id]);
            seriesOptions.name = this.getSeriesName(this.data[j].id);

            seriesOptions.data = this.data[j].data.sort(function (a, b) {
              return (a[0] < b[0]) ? -1 : ((a[0] > b[0]) ? 1 : 0);
            });

            // set dates as MMM DD
            seriesOptions.data = controller.mapDateToNewdate(seriesOptions.data);

            this._chartOptions.series.push(seriesOptions);
          }
        }
        for (let i = 0; i < this._chartOptions.series.length; i++) {
        }
        // set x-axis labels to match MMM DD
        this.data[0].data.forEach(element => {
          controller.xLabels.push(element[0]);
        });

        this.displayChart = true;
      });

  }


  private getSeriesName(seriesId) {
    let name = this.getSeriesYearText(seriesId);

    if (seriesId === 'previous_range') {
      name += ' range';
    }

    return name;
  }

  private getSeriesYearText(seriesId) {
    let text = '';
    if (seriesId === 'previous_range') {
      if (this.firstPointYear === this.lastPointYear) {
        text = (this.firstPointYear - 5).toString() + '-' + (this.firstPointYear - 1).toString();
      } else {
        text = (this.firstPointYear - 5).toString() + '-' + ((this.firstPointYear - 1)).toString() + '/' + (this.lastPointYear - 5).toString() + '-' + ((this.lastPointYear - 1)).toString();
      }
    } else if (seriesId === 'current') {
      if (this.firstPointYear === this.lastPointYear) {
        text = this.firstPointYear.toString();
      } else {
        text = this.firstPointYear.toString() + '/' + (this.lastPointYear).toString();
      }
    } else if (seriesId === 'previous') {
      if (this.firstPointYear === this.lastPointYear) {
        text = (this.firstPointYear - 1).toString();
      } else {
        text = (this.firstPointYear - 1).toString() + '/' + ((this.lastPointYear - 1)).toString();
      }
    }

    return text;
  }

  private mapDateToNewdate(array) {
    return array.map(element => {
      element[0] = Utils.dateAsMMMDD(new Date(element[0]));
      return element;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/share-modules/eia-charts/display-gas-trade-disposition/display-gas-trade-disposition.component.ts